import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import api from '@/services/api';
import { setCredentials } from '@/store/authSlice';
import { useToast } from '@/components/ui/atoms/MToastProvider';
import MLoader from '@/components/ui/atoms/MLoader';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showToast } = useToast();

  useEffect(() => {
    const doGoogleLogin = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('token') || params.get('code');
        if (!code) {
          showToast({ message: 'Missing Google code/token', variant: 'error' });
          navigate('/login?error=google-missing-token');
          return;
        }
        // Call backend Google login endpoint
        const { data } = await api.post('/auth/google/login', { code });
        if (data.token && data.member) {
          dispatch(setCredentials({ token: data.token, member: data.member }));
          navigate('/dashboard');
        } else {
          showToast({ message: data.message || 'Google login failed', variant: 'error' });
          navigate('/login?error=google-bad-response');
        }
      } catch (err: any) {
        const backendMsg = err?.response?.data?.message;
        const msg = Array.isArray(backendMsg) ? backendMsg.join(', ') : backendMsg || err.message || 'Google login failed';
        showToast({ message: msg, variant: 'error' });
        navigate('/login?error=google-exception');
      }
    };
    doGoogleLogin();
    // eslint-disable-next-line
  }, []);

  return <MLoader />;
};

export default AuthCallback;
